export default __webpack_public_path__ + "static/media/Belgie.7644e11e.svg";